/* eslint no-shadow: "off" */
import en from '@/locales/en.json';
import nl from '@/locales/nl.json';

export enum Locales {
  EN = 'en',
  NL = 'nl',
}

function getUserLanguage(): string {
  const lang = navigator.language;
  if (lang.toUpperCase().includes('EN')) {
    return Locales.EN;
  }
  return Locales.NL;
}

export const locale = getUserLanguage();
export const defaultLocale = Locales.NL;

export const messages = {
  [Locales.EN]: en,
  [Locales.NL]: nl,
};
